import { __assign } from "tslib";
import React, { Fragment } from 'react';
import { IconSVG } from '../icon-svg/icon-svg';
export var IconBuyOnline = function (SVGprops) {
    return (React.createElement(IconSVG, __assign({ viewBox: "0 0 18 18" }, SVGprops),
        React.createElement(Fragment, null,
            React.createElement("path", { d: "M16.1772 12.99L13.5222 10.335L14.9097 8.9475L5.99219 6L8.94719 14.91L10.3347 13.5225L12.9897 16.1775L16.1697 12.9975L16.1772 12.99ZM10.8747 11.9325L10.3422 11.4L9.60719 12.1275L8.35469 8.355L12.1272 9.6075L11.3922 10.3425L12.4497 11.4L14.0397 12.99L12.9822 14.0475L11.3922 12.4575L10.8597 11.925L10.8747 11.9325Z" }),
            React.createElement("path", { d: "M8.25 1.5H6.75V4.5H8.25V1.5Z" }),
            React.createElement("path", { d: "M4.5 6.75H1.5V8.25H4.5V6.75Z" }),
            React.createElement("path", { d: "M3.31066 2.24891L2.25 3.30957L4.37132 5.43089L5.43198 4.37023L3.31066 2.24891Z" }))));
};
